import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Input from './Input';
import Select from './Select';
import TextArea from './TextArea';
import Button from './Button';
import { InventoryCategory } from '../../types';

interface InventoryCategoryFormProps {
  onSubmit: (data: Omit<InventoryCategory, 'id' | 'createdAt' | 'updatedAt'>) => void;
  initialData?: InventoryCategory;
  onCancel: () => void;
}

const InventoryCategoryForm: React.FC<InventoryCategoryFormProps> = ({ onSubmit, initialData, onCancel }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm<InventoryCategory>({
    defaultValues: initialData || {
      name: '',
      description: '',
      isActive: true
    }
  });

  useEffect(() => {
    if (initialData) {
      reset(initialData);
    }
  }, [initialData, reset]);

  const handleFormSubmit = (data: InventoryCategory) => {
    onSubmit(data);
    if (!initialData) {
      reset();
    }
  };

  const statusOptions = [
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' }
  ];

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-6">
      <Input
        label="Category Name"
        type="text"
        placeholder="e.g., Engine Parts, Safety Equipment"
        required
        {...register('name', { required: 'Category name is required' })}
        error={errors.name?.message}
      />

      <TextArea
        label="Description"
        {...register('description')}
        error={errors.description?.message}
        placeholder="Category description..."
        rows={3}
      />

      <Select
        label="Status"
        {...register('isActive', { 
          setValueAs: (value) => value === 'true'
        })}
        options={statusOptions}
        error={errors.isActive?.message}
      />

      <div className="flex justify-end space-x-3 pt-4">
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="primary"
        >
          {initialData ? 'Update Category' : 'Add Category'}
        </Button>
      </div>
    </form>
  );
};

export default InventoryCategoryForm;

